module.exports = __webpack_public_path__ + "58c07750e763b401127136310aa8a1f6.svg";